import page from './page';
import ElementReplacer from "../helpers/element-replacer";
import Server from "helpers/server";
import Events from 'events/events';
import quantityField from '../components/quantity-field';
import productCarousel from '../components/carouselRefactor/productCarousel';
import subtotalRecalculation from 'helpers/subtotal-recalculate';
import Tooltips from '../components/tooltips/tooltips';
import ScrollToLink from '../components/skip-links';
import Swatches from '../components/swatch-list';
import displayedProductEvent from '../components/recently-viewed/recently-view-event-dispatcher';
import initShareModal, { unmount as unmountShareModal } from '../components/share-modal';
import initBrandLink, { unmount as unmountBrandLink } from '../components/brand-link';
import initOOSActionButtons, { unmount as unmountOOSActionButtons } from '../components/oos-action-buttons';
import initWishListLoader, { unmount as unmountWishListLoader } from '../components/wish-list-loader';
import ClickAndCollectCountdown, {unmount as unmountClickAndCollect} from '../components/click-and-collect-countdown';
import {ReactAccordion} from '../components/accordion';
import initProductDescription from '../components/product-description';
import {Swatch} from '../components/pdpSwatches';
import {ProductEmailMe} from '../components/product-email';
import FabricByLengthPriceCalculator from "../components/fabric-by-length/fabric-by-length-price-calculator";
import {initMinQuantity} from "../components/min-length-quantity"
import {isIE} from "react-device-detect";

const initRatingsAndReviews = () => {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  let bvElement;
  if (isMobile) {
    bvElement = document.querySelector('.show-on-desktop #skip-link--product-detail--reviews');
  } else {
    bvElement = document.querySelector('.show-on-mobile #skip-link--product-detail--reviews');
  }
  if (bvElement) {
    bvElement.parentNode.removeChild(bvElement);
  }
  let linkSelector = '#skip-link--product-detail--reviews';
  ScrollToLink(linkSelector, null, new CustomEvent('jl-events.browser.loadReviews', {}));
};

const initStickyLeftColumn = (init) => {
  const decider = () => {
    if(window.innerWidth > 767 && !isIE) {
      const paddingOffset = 32;
      const leftColumn = document.querySelector(".standard-product-column-left, .bundle-product-column-left");
      const rightColumn = document.querySelector(".standard-product-column-right-desktop, .bundle-product-column-right");
      const carousel = leftColumn.querySelector(".carousel");
      const thumbnails = leftColumn.querySelector(".thumbnail-container");
      const carouselOffsetHeight = carousel ? carousel.offsetHeight : 0;
      const thumbnailsOffsetHeight = thumbnails ? thumbnails.offsetHeight : 0;
      const imageAreaHeight = carouselOffsetHeight + thumbnailsOffsetHeight + paddingOffset;
      const rightColumnHeight = rightColumn.offsetHeight + 100;

      // eslint-disable-next-line no-console
      window.debugscrolling && console.log("Carousel area height: ", imageAreaHeight, "Window height: ", window.innerHeight);
      // eslint-disable-next-line no-console
      window.debugscrolling && console.log("Right column height: ", rightColumnHeight, "Window height: ", window.innerHeight);

      if(imageAreaHeight > window.innerHeight) {
        // eslint-disable-next-line no-console
        window.debugscrolling && console.log("Sticky left bottom");
        leftColumn.classList.add("sticky-bottom");
        leftColumn.classList.remove("sticky-top");
      } else {
        // eslint-disable-next-line no-console
        window.debugscrolling && console.log("Sticky left top");
        leftColumn.classList.add("sticky-top");
        leftColumn.classList.remove("sticky-bottom");
      }

      if(rightColumnHeight > window.innerHeight) {
        // eslint-disable-next-line no-console
        window.debugscrolling && console.log("Sticky right bottom");
        rightColumn.classList.add("sticky-bottom");
        rightColumn.classList.remove("sticky-top");
      } else {
        // eslint-disable-next-line no-console
        window.debugscrolling && console.log("Sticky right top");
        rightColumn.classList.add("sticky-top");
        rightColumn.classList.remove("sticky-bottom");
      }
    }
  }
  if(init) {
    decider();
  } else {
    window.addEventListener("resize", () => decider());
    window.addEventListener('DOMContentLoaded', () => decider());
    window.addEventListener('swatchChanged', () => decider());

  }
}

const initAccordions = () => {
  let accordions = document.querySelectorAll('[data-accordion]');
  if (accordions) {
    for (let i = 0; i < accordions.length; i++) {
      ReactAccordion.init(accordions[i], i);
    }
  }
};

const initProductEmailMe = productEmailMeClass => {
  ProductEmailMe.init(`.${productEmailMeClass}`);
};

const initTooltips = tooltipClass => {
  const tooltips = new Tooltips({
    container: tooltipClass
  });
  tooltips.init();
};

const initSwatches = pageType => {
  if (pageType) {
    let sizeSwatches = document.querySelectorAll('.size-link');
    let colourSwatches = document.querySelectorAll('.swatch');
    let swatches = [...sizeSwatches, ...colourSwatches];

    let reInit;
    if (pageType === 'standard') {
      reInit = initStandardPDP;
    } else {
      console.warn('pageType not recognised - set it where you call initSwatches');
      return;
    }

    if (swatches.length > 0) {
      for (let swatch of swatches) {
        let obj = {
          el: swatch,
          reInit,
          unmountReact,
        }
        new Swatch(obj);
      }
    }
  } else {
    console.warn('You need to include a pageType for the reinitialisation function');
  }
}

addGridPositionToJlData();
addSearchRedriectMetricToJLData();

const unmountReact = () => {
  unmountClickAndCollect();
  unmountShareModal();
  unmountBrandLink();
  unmountOOSActionButtons()
  unmountWishListLoader();
}

const reloadPage = () => {
  const newAtb = document.querySelector('[data-test="new-atb"]')
  if(newAtb) return

  const url = window.document.location.href;
  Server.getHtml(
    url,
    { method: "GET", credentials: "same-origin" },
  ).then( response => {
    let doc = response.bodyDocument;
    let pageData = response.jsonPageData;
    if(pageData) window.jsonPageData.innerHTML = pageData;
    ElementReplacer.replace(doc, 'main');
    Events.tooltipsReinit.trigger();
    Events.addToBasketReinit.trigger();
    Events.reviewsReinit.trigger();
    initStandardPDP();
    initStickyLeftColumn(true);
    window.dispatchEvent(new Event('reloadPage'))
  }).catch((err) => {
    console.error(err);
    window.document.location = url;
  });
}

function setStandardPDPCutoverFLag(){
  const standardPDPCutover = document.querySelector("[data-test='standardPDPCutover']")
  if(standardPDPCutover) {
    window.standardPDPCutover = true;
  }
}

const initStandardPDP = () => {
  if (productCarousel.isValid()) productCarousel.buildCarousel();
  ScrollToLink('.reviews-summary', '#product-detail--reviews button');
  subtotalRecalculation.init();
  quantityField.init('add-to-basket-form');

  initAccordions();
  initTooltips('.product-detail__content--specifications');
  initProductEmailMe('product-detail__email-me-container');
  initSwatches('standard');
  initProductDescription();

  if (Swatches.arePresent()) Swatches.initProductPageSwatches();

  window.jlData.page.productPages && displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku);

  FabricByLengthPriceCalculator.init();
  initRatingsAndReviews();
  initShareModal();
  initBrandLink();
  initOOSActionButtons();
  initWishListLoader();
  initMinQuantity();
  ClickAndCollectCountdown();
  initStickyLeftColumn();

  document.body.dispatchEvent(
    new CustomEvent('displayedProduct', {
      detail: {
        skuId: window.jlData.page.productPages.displayedSku,
      },
    }),
  );
}

page('.standard-product-page-main', () => {
  initStandardPDP();
  setStandardPDPCutoverFLag();
  window.addEventListener('jl-events.browser.basketQuantityUpdated', (event) => {
    if (event.detail && event.detail && event.detail.origin === 'side-basket') {
      reloadPage();
    }
  });
});

page('.m2m-roller-blinds-product-page-main', () => {
  initProductEmailMe('product-detail__email-me-container');
  if (productCarousel.isValid()) productCarousel.buildCarousel();
  displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku);
});

page('.m2m-roman-blinds-product-page-main', () => {
  initProductEmailMe('product-detail__email-me-container');
  if (productCarousel.isValid()) productCarousel.buildCarousel();
  displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku, 'true');
});

page('.m2m-curtains-product-page-main', () => {
  initProductEmailMe('product-detail__email-me-container');
  if (productCarousel.isValid()) productCarousel.buildCarousel();
  displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku);
});

page('.bundle-page-main', () => {
  setStandardPDPCutoverFLag();
  initAccordions();
  initWishListLoader();
  initTooltips('.bundle-detail__content--specifications');
  if (productCarousel.isValid()) productCarousel.buildCarousel();
  ScrollToLink('.reviews-summary', '#product-detail--reviews button');
  subtotalRecalculation.init();
  quantityField.init('add-to-basket-form');
  initStickyLeftColumn();
  displayedProductEvent(window.jlData.page.productPages.productId, window.jlData.page.productPages.displayedSku);
});

function addGridPositionToJlData() {
  const productContainer = document.querySelector('.standard-product-page-main[data-findability-grid-position="on"], .chanel-product-page-main');

  if (!productContainer) {
    return;
  }

  const storage = window.sessionStorage;
  const pos = storage ? parseInt(storage.getItem('gridPosition'), 10) : NaN;

  if (!isNaN(pos)) {
    window.jlData.page.productPages.gridPosition = pos;
    storage.removeItem('gridPosition');
  }
}
function addSearchRedriectMetricToJLData() {
  const url = window.location.href;
  const urlParams =getUrlParams(url);
  const originalSearchTerm = urlParams['originalSearchTerm'];
  if( originalSearchTerm!=null ){
    const originalSearchTermMetric={ "searchMethod": "search redirect", "searchTerms": originalSearchTerm }
    window.jlData.page.search = originalSearchTermMetric;
  }
}
function getUrlParams(search) {
  const hashes = search.slice(search.indexOf('?') + 1).split('&')
  const params = {}
  hashes.map(hash => {
    const [key, val] = hash.split('=')
    params[key] = decodeURIComponent(val)
  })
  return params
}

